'use strict';


const tooltipCollection = [
    {
        name: 'termin-datum',
        title: 'Datum',
        text: 'Hier müssen Sie ein Datum angeben, an dem der Termin stattfindet.'
    },
    {
        name: 'termin-start',
        title: 'Anfangszeit',
        text: 'Hier müssen Sie die Uhrzeit angeben, wann der Termin beginnt.'
    },
    {
        name: 'termin-ende',
        title: 'Endzeit',
        text: 'Hier müssen Sie die Uhrzeit angeben, wann der Termin endet.'
    },
    {
        name: 'termin-stufe',
        title: 'Stufe',
        text: 'Hier müssen Sie die Stufe angeben, in der der Termin stattfindet.'
    },
    {
        name: 'termin-klassen',
        title: 'Klassen- oder Kursbezeichnung',
        text: 'Hier können Sie die Klassen- oder Kursbeschreibung angeben, in der der Termin stattfindet.'
    },
    {
        name: 'termin-raumbezeichnung',
        title: 'Raumbezeichnung',
        text: 'Hier können Sie die Raumbezeichnung angeben, in der der Termin stattfindet.'
    },
    {
        name: 'termin-ausstattung',
        title: 'Ausstattung',
        text: 'Hier können Sie die Ausstattung angeben, die im bereitgestellen Raum zur Verfügung steht.'
    },
    {
        name: 'termin-nicht-erwünschte',
        title: 'NICHT erwünschte Betriebskategorien',
        text: 'Hier können Sie Betriebskategorien angeben, die für diesen Termin unerwünscht sind.'
    },
    {
        name: 'termin-ablaufzeit',
        title: 'Ablaufzeit',
        text: 'Hier müssen Sie die Ablaufzeit angeben, wie viele Stunden vor Terminbeginn der Termin nicht mehr buchbar sein soll.'
    },
    {
        name: 'termin-kontaktperson',
        title: 'Kontaktperson',
        text: 'Hier müssen Sie die Kontaktperson angeben, die für diesen Termin als Ansprechpartner dient.'
    },
    {
        name: 'startseite-postleitzahl',
        title: 'Postleitzahl',
        text: 'Hier können Sie die Postleitzahl angeben, in der Sie nach teilnehmenden Schulen suchen möchten.'
    },
    {
        name: 'startseite-umkreis',
        title: 'Umkreis',
        text: 'Hier können Sie angeben, in welchem Umkreis in Kilometern um die angegebene Postleitzahl nach teilnehmenden Schulen gesucht wird.'
    },
    {
        name: 'registrierung-schulname',
        title: 'Schulname',
        text: 'Hier müssen Sie angeben, welchen Namen die zu registrierende Schule trägt.'
    },
    {
        name: 'registrierung-schulform',
        title: 'Schulform',
        text: 'Hier müssen Sie die Schulform der Schule angeben.'
    },
    {
        name: 'registrierung-schule-telefonnummer',
        title: 'Telefonnummer',
        text: 'Hier müssen Sie die Telefonnummer angeben, unter der diese Schule ist bzw. Sie als Admin-Nutzer der Schule erreichbar sind.'
    },
    {
        name: 'registrierung-anrede',
        title: 'Anrede',
        text: 'Hier müssen Sie die Anrede angeben, mit der Sie angesprochen werden möchten.'
    },
    {
        name: 'registrierung-titel',
        title: 'Titel',
        text: 'Hier können Sie den Title angeben, mit dem Sie angesprochen werden möchten.'
    },
    {
        name: 'registrierung-vorname',
        title: 'Vorname',
        text: 'Hier müssen Sie Ihren Vornamen angeben.'
    },
    {
        name: 'registrierung-nachname',
        title: 'Nachname',
        text: 'Hier müssen Sie Ihren Nachnamen angeben.'
    },
    {
        name: 'registrierung-e-mail-adresse',
        title: 'E-Mail-Adresse',
        text: 'Hier müssen Sie Ihre E-Mail-Adresse angeben, unter der Ihr Account registriert wird.'
    },
    {
        name: 'registrierung-e-mail-wiederholen',
        title: 'E-Mail wiederholen',
        text: 'Hier müssen Sie Ihre E-Mail-Adresse wiederholen.'
    },
    {
        name: 'registrierung-benutzername',
        title: 'Benutzername',
        text: 'Hier müssen Sie einen Benutzernamen angeben, mit dem Sie sich registrieren möchten. Der Benutzername darf kein "@" enthalten.'
    },
    {
        name: 'registrierung-passwort',
        title: 'Passwort',
        text: 'Hier müssen Sie das Passwort angeben, mit dem Sie sich zukünftig einloggen möchten. Das Passwort muss mindestens 6 Zeichen lang sein.'
    },
    {
        name: 'registrierung-passwort-wiederholen',
        title: 'Passwort wiederholen',
        text: 'Hier müssen Sie Ihr Passwort wiederholen.'
    },
    {
        name: 'registrierung-unternehmensbezeichnung',
        title: 'Unternehmensbezeichnung',
        text: 'Hier müssen Sie angeben, wie Ihr Unternehmen bezeichnet wird.'
    },
    {
        name: 'registrierung-betriebskategorie',
        title: 'Betriebskategorie',
        text: 'Hier müssen Sie die Betriebskategorie angeben, unter die Ihr Unternehmen fällt. Dies kann auch mehr als eine Kategorie sein.'
    },
    {
        name: 'registrierung-handelsregisternummer',
        title: 'Handelsregisternummer',
        text: 'Hier müssen Sie die Handelsregisternummer angeben, unter der Ihr Unternehemen aufgeführt wird.'
    },
    {
        name: 'registrierung-amtsgericht',
        title: 'Amtsgericht',
        text: 'Hier müssen Sie das Amtsgericht angeben, das für Ihr Unternehmen zuständig ist.'
    },
    {
        name: 'registrierung-unternehmen-telefonnummer',
        title: 'Telefonnummer',
        text: 'Hier müssen Sie die Telefonnummer angeben, unter der Sie erreichbar sind.'
    },
    {
        name: 'abweichende-e-mail-adresse',
        title: 'E-Mail-Adresse Rechnung',
        text: 'Hier müssen Sie die E-Mail-Adresse angeben, an die Ihre Rechnungen gesendet werden sollen.'
    },
    {
        name: 'abweichende-straße',
        title: 'Straße Rechnung',
        text: 'Hier müssen Sie die Straße angeben, in der sich der Empfänger der Rechnung befindet.'
    },
    {
        name: 'abweichende-hausnummer',
        title: 'Hausnummer Rechung',
        text: 'Hier müssen Sie die Hausnummer des Rechnungsempfänger angeben.'
    },
    {
        name: 'abweichende-postleitzahl',
        title: 'Postleitzahl Rechnung',
        text: 'Hier müssen Sie die Postleitzahl angeben, in der sich der Empfänger der Rechnung befindet.'
    },
    {
        name: 'abweichende-stadt',
        title: 'Stadt',
        text: 'Hier müssen Sie die Stadt angeben, in der sich der Empfänger der Rechnung befindet.'
    },
    {
        name: 'login-name',
        title: 'E-Mail-Adresse oder Username',
        text: 'Hier müssen Sie entweder E-Mail-Adresse oder Username angeben, die Sie bei der Registrierung festgelegt haben.'
    },
    {
        name: 'login-passwort',
        title: 'Passwort login',
        text: 'Hier müssen Sie das Passwort angeben, das Sie bei der Registrierung festgelegt haben. Das Passwort muss mindestens 6 Zeichen lang sein.'
    },
    {
        name: 'organisationsdaten-standard-ausstattung',
        title: 'Standard-Ausstattund',
        text: 'Hier können Sie die Standard-Ausstattung angeben. Die Standard-Austattung wird automatisch bei einer Terminerstellung hinzugefügt und können dann auch wieder individuell entfernt werden. Hier können mehrere Angaben getroffen werden.'
    },
    {
        name: 'terminsuche-postleitzahl',
        title: 'Postleitzahl',
        text: 'Hier können Sie die Postleitzahl oder einen Teil der Postleitzahl angeben, um in diesen Orten nach Terminen zu suchen.'
    },
    {
        name: 'terminsuche-umkreis',
        title: 'Umkreis',
        text: 'Hier können Sie den Umkreis angeben, in dem mit der angegebenen Postleitzahl als Basis nach Terminen gesucht wird.'
    },
    {
        name: 'terminsuche-schulform',
        title: 'Schulform',
        text: 'Hier können Sie eine oder mehrere Schulformen angeben, von denen Sie Termine sehen möchten.'
    },
    {
        name: 'terminsuche-stufe',
        title: 'Stufe',
        text: 'Durch das Bewegen der beiden Auswahlpunkte kann festgelegt werden, in welchem Bereich von Stufen Termine angezeigt werden.'
    },
    {
        name: 'anrede',
        title: 'Anrede',
        text: 'Hier müssen Sie die Anrede angeben.'
    },
    {
        name: 'titel',
        title: 'Titel',
        text: 'Hier können Sie einen Title angeben.'
    },
    {
        name: 'vorname',
        title: 'Vorname',
        text: 'Hier müssen Sie einen Vornamen angeben.'
    },
    {
        name: 'nachname',
        title: 'Nachname',
        text: 'Hier müssen Sie einen Nachnamen angeben.'
    },
    {
        name: 'email',
        title: 'E-Mail-Adresse',
        text: 'Hier müssen Sie einen E-Mail-Adresse angeben.'
    },
    {
        name: 'telefon',
        title: 'Telefon',
        text: 'Hier können Sie einen Telefonnummer angeben.'
    },
    {
        name: 'kontaktperson-standard',
        title: "Standard-Kontaktperson",
        text: 'Hier können Sie auswählen, ob die Person neue standard Kontaktperson werden soll.'
    },
    {
        name: 'straße',
        title: 'Straße',
        text: 'Hier müssen Sie die Straße angeben.'
    },
    {
        name: 'hausnummer',
        title: 'Hausnummer',
        text: 'Hier müssen Sie die Hausnummer angeben.'
    },
    {
        name: 'postleitzahl',
        title: 'Telefon',
        text: 'Hier müssen Sie die Postleitzahl angeben.'
    },
    {
        name: 'stadt',
        title: 'Stadt',
        text: 'Hier müssen Sie die Stadt angeben.'
    }
];

export default tooltipCollection;
